import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=cda936ae&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cda936ae')) {
      api.createRecord('cda936ae', component.options)
    } else {
      api.reload('cda936ae', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=cda936ae&", function () {
      api.rerender('cda936ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22IB2mcVOfTtg/JS/cancellationPolicy.vue"
export default component.exports